var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.3 307.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke: #ed1c24;\n        stroke-dasharray: 1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.5,
    y: 0.5,
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.07,18.78c-6.07,25.9.42,53.11,7.28,80.6,4.39,17.78,8.96,35.66,10.36,53.39,4.01,49.47-32.67,85.55-35,133.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.81,285.17c-1.02-14.41,3.94-27.54,7.85-41.15,4.35-15.17,7.41-30.83,7.32-46.66-.08-15.69-3.39-31.64-11.02-45.45-5.73-10.38-19.99-29.26-7.9-40.25,3.78-3.45,7.33-7.56,9.57-12.27,1.31-2.75,2.15-5.69,2.33-8.87.47-7.65-2.1-16.57-5.65-23.24-8.45-16.15-20.96-32.06-31.13-48.49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.41,142.88s32.54,27.54,11.73,85.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations23);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-23.c47129ade217e2af5dbe6c0f9d5bf5c2.svg";
export { ForwardRef as ReactComponent };